import React from 'react';

import {StudyPhase} from 'graphql-client/__generated/graphqlGlobalTypes';
import StepNav from 'ui-library/StepNav';
import {StepItemStatus} from 'ui-library/StepNav';

interface StudyPhaseOverviewProps {
  study: {phase: StudyPhase};
}

export default function StudyPhaseOverview({study}: StudyPhaseOverviewProps): JSX.Element {
  return (
    <StepNav<StudyPhase>
      steps={[
        {
          key: StudyPhase.DESIGN,
          title: 'Design',
        },
        {
          key: StudyPhase.EXECUTION,
          title: 'Execution',
        },
      ]}
      statusByStep={{
        [StudyPhase.DESIGN]:
          study.phase !== StudyPhase.DESIGN ? StepItemStatus.DONE : StepItemStatus.UNVISITED,
        [StudyPhase.EXECUTION]:
          study.phase === StudyPhase.COMPLETE ? StepItemStatus.DONE : StepItemStatus.UNVISITED,
        [StudyPhase.COMPLETE]:
          study.phase === StudyPhase.COMPLETE ? StepItemStatus.DONE : StepItemStatus.UNVISITED,
      }}
      currentStepKey={study.phase}
      onUpdateCurrentStep={undefined}
    />
  );
}
